// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"265":"b0b54513","313":"b0b54513","498":"b0b54513","530":"b0b54513","591":"b0b54513","758":"b0b54513","787":"b0b54513","925":"b0b54513","927":"b0b54513","990":"b0b54513"}[chunkId] + ".chunk.css";
};